module.exports = __webpack_public_path__ + "static/media/alliedWasteServices.a303b566.png";